import React, { useState } from 'react';
import { isAuthenticated } from '../apiCallsHelper/authapicalls';
import { createTask } from '../apiCallsHelper/taskapicalls';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingOverlay from './../utils/LoadingOverlay';


const TaskForm = ({ findTodo, isTaskSubmitted, setIsTaskSubmitted, setIsTasksAvailable, setTodoTitle }) => {

    const { user, token } = isAuthenticated();

    const [task, setTask] = useState("");
    const [isLoading, setIsLoading] = useState(false);



    const onSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (findTodo != null) {
            createTask(findTodo, user._id, token, { task: task })
                .then(data => {
                    if (data.error) {
                        setIsLoading(false);
                        toast.error(data.error, { theme: "dark", style: { width: "200px", marginLeft: "120px" } })
                    }
                    else {
                        setIsLoading(false);
                        setTask("");
                        toast.success(data.message, { theme: "dark", style: { width: "200px", marginLeft: "120px" } })
                        setIsTaskSubmitted(!isTaskSubmitted);
                        setIsTasksAvailable(true)
                        setTodoTitle(data.tasks.title);
                    }
                })
        }
    }



    return (
        <>
            <div>
                <div className=" w-[130px]  xs:w-[150px]  mobSm:w-[170px]   sm:w-[220px]  mobLg:w-full       md:w-full md:h-[430px]   smLaptop:w-[258px] smLaptop:h-[270px]    lg:w-[265px] lg:h-[270px]    xl:w-full xl:h-[270px] ">
                    {isLoading && <LoadingOverlay />}
                    <form className="    h-[325px] px-2 pt-8 md pb-4   xs:h-[365px] xs:px-2 xs:pt-16 xs:pb-4      mobSm:h-[415px] mobSm:px-2 mobSm:pt-20 mobSm:pb-4     sm:h-[420px] sm:px-8 sm:pt-20 sm:pb-4      mobLg:h-[420px] mobLg:px-8 mobLg:pt-20 mobLg:pb-4    md:h-[420px] md:px-8 md:pt-20 md:pb-8    smLaptop:px-2 smLaptop:pt-6 smLaptop:pb-12 smLaptop:mb-4 smLaptop:h-[260px]  lg:px-2 lg:pt-2 lg:pb-8 lg:mb-4 lg:h-[260px]  xl:px-8 xl:pt-2 xl:pb-8 xl:mb-4 xl:h-[260px]   bg-white shadow-md rounded">
                        <div className="mb-4  ">
                            <label className="block text-[#506499]  smLaptop:text-[20px] font-bold mb-2" htmlFor="task">
                                <div className='  text-[12px] sm:text-[12px]  sm:text-[15px] mobLg:text-[18px]  md:text-[18px]  smLaptop:text-[15px]   lg:text-[15px]  xl:text-[15px] font-normal '>Having a hard time remembering tasks? Not anymore!</div>
                                <div className=' text-[18px] sm:text-[18px] sm:mt-4   mobLg:text-[22px]   md:mt-4  md:text-[22px]  smLaptop:mt-2 smLaptop:text-[22px]     lg:text-[22px]     xl:text-[22px]   '>Add task & just relax!</div>
                            </label>
                            <input className="  w-full    py-2 px-3     sm:mt-4  md:mt-4   smLaptop:mt-2    shadow appearance-none border rounded text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Please enter task..."
                                value={task}
                                onChange={(event) => setTask(event.target.value)}
                                required
                            />
                        </div>
                        <div className=" sm:mt-4   md:mt-8 smLaptop:mt-4     flex items-center justify-between  ">
                            <button onClick={onSubmit} className="   py-2 px-4      md:py-2 md:px-4      smLaptop:py-2 smLaptop:px-4   lg:py-2 lg:px-4     xl:py-2 xl:px-4   bg-[#8aabff] hover:bg-[#5772b3] text-white font-bold  rounded focus:outline-none focus:shadow-outline">
                                Add Task
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}



export default TaskForm;